export default __webpack_public_path__ + "static/media/sunny.8777319c.svg";